import React from "react";
import "./headboard.scss";
import { ReferenciaCabecera } from "../../../interfaces/ReferenciaCabecera";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { OptimizeImage } from "../../../shared/utils/stringUtilities";

// Components //
import SearchContent from "../../../components/molecules/search-content/searchContent"
import Breadcrumb from '../../atoms/breadcrumb/breadcrumb';

const Headboard = (props: ReferenciaCabecera) => {

    return (
        <div className={`o-headboard ${props.contentful_id === "3TpnPDaoxP6KVdLpRcmh3U" || "6bHPbDRBgWSln5OcQEeCXT" || "61mywN9X1eUkMGRoF9YudX" || "190Dxeb6aE4Ll3C20uZOaP" ? "header-comunidades" : ""}`}>
            <div className="container">
                <Breadcrumb content={props.migaDePan} />
                <div className="o-headboard__container">
                    <div className="o-headboard__container__content">
                        {props.tituloPrincipal && (
                            <h1 className="o-headboard__container__content__title">
                                {props.tituloPrincipal}
                            </h1>
                        )}
                        {props.descripcion && (
                            <article className="o-headboard__container__content__text">
                                {props.descripcion.json.content &&
                                    documentToReactComponents(
                                        props.descripcion.json
                                    )}
                            </article>
                        )}
                        {props.contentful_id === "3TpnPDaoxP6KVdLpRcmh3U" && (
                            <SearchContent type="bibliotecaComunidadesEmpleo"/>
                        )}
                        {props.contentful_id === "61mywN9X1eUkMGRoF9YudX" && (
                            <SearchContent type="bibliotecaPersonasEmpleo" page="mainPage" />
                        )}
                        {props.contentful_id === "190Dxeb6aE4Ll3C20uZOaP" && (
                            <SearchContent type="bibliotecaEmpresasEmpleo" page="mainPage" />
                        )}
                        {props.contentful_id === "6bHPbDRBgWSln5OcQEeCXT" && (
                            <SearchContent type="foroEmpleo" />
                        )}
                    </div>
                    {props.imagenHeader ? (
                        <div className="o-headboard__container__cover">
                            {props.imagenHeader && (
                                <img
                                    className="o-headboard__container__cover__img"
                                    src={OptimizeImage(
                                        props.imagenHeader.file.url,
                                        props.imagenHeader.file.contentType,
                                        550
                                    )}
                                    alt={
                                        (props.imagenHeader &&
                                            props.imagenHeader.title) ||
                                        "imagen cabecera"
                                    }
                                    loading="lazy"
                                />
                            )}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Headboard;
